module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside-1160.66706fbf.svg";